(function(){
  'use strict';
  document.addEventListener('input',e=>{
    if(!e.target.matches('[data-directory-search]'))return;
    let count=0;document.querySelectorAll('[data-directory-brand]').forEach(a=>{a.hidden=!a.dataset.directoryBrand.includes(e.target.value.trim().toLocaleLowerCase('it'));if(!a.hidden)count++;});
    document.querySelector('[data-directory-empty]').hidden=count>0;
  });
  // Native Shopify search supports facets on larger catalogues than collection Liquid.
  // Only mirror known rule-based collections: curated/manual collections retain their products.
  const scopes={
    'pneumatici-auto-estivi':['auto','summer'],'pneumatici-auto-invernali':['auto','winter'],'pneumatici-auto-4-stagioni':['auto','all-season'],
    'pneumatici-moto':['moto'],'pneumatici-furgone-truck':['truck'],
    'pneumatici-estivi':['','summer'],'pneumatici-invernali':['','winter'],'pneumatici-4-stagioni':['','all-season'],
    'marche-premium':['','','premium'],'marche-quality':['','','quality'],'marche-economiche':['','','discount'],all:[]
  };
  const shell=document.querySelector('[data-collection-handle]'),scope=scopes[shell?.dataset.collectionHandle];
  if(!shell||!scope||Number(shell.dataset.collectionTotal)<=5000)return;
  const url=new URL(window.gommaDOT.routes.search,location.origin),incoming=new URLSearchParams(location.search);
  url.searchParams.set('q',[scope[0]&&`tag:${scope[0]}`,scope[1]&&`tag:${scope[1]}`].filter(Boolean).join(' AND ')||'*');
  url.searchParams.set('type','product');url.searchParams.set('options[prefix]','none');url.searchParams.set('options[unavailable_products]','hide');
  if(scope[2])url.searchParams.set('filter.p.m.tyre.brand_category',scope[2]);
  incoming.forEach((v,k)=>{if(k.startsWith('filter.')||k==='sort_by'||k==='page')url.searchParams.append(k,v);});
  const resultUrl=url.toString();url.searchParams.set('section_id','main-search');
  shell.setAttribute('aria-busy','true');
  fetch(url).then(r=>{if(!r.ok)throw new Error('search');return r.text();}).then(html=>{
    const doc=new DOMParser().parseFromString(html,'text/html'),body=doc.querySelector('[data-catalog-body]');
    if(!body)throw new Error('results');
    body.querySelectorAll('[data-sort-select]').forEach(el=>el.dataset.resultsUrl=resultUrl);
    body.querySelectorAll('[data-tyre-search-form]').forEach(form=>{form.dataset.initialVehicle=scope[0]||'';form.dataset.initialSeason=scope[1]||'';});
    shell.querySelector('[data-catalog-body]').replaceWith(body);shell.dataset.resultCount=doc.querySelector('#ShopResults').dataset.resultCount;
    document.dispatchEvent(new CustomEvent('gommadot:content-updated',{detail:body}));
  }).catch(()=>{
    const hint=shell.querySelector('.catalog-filter-hint');
    if(hint){const link=document.createElement('a');link.href=resultUrl;link.textContent='Apri i filtri del catalogo';hint.append(document.createElement('br'),link);}
  }).finally(()=>shell.removeAttribute('aria-busy'));
})();
